var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle",
      "gutter": [40, 40]
    }
  }, [_c('a-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h1', [_vm._v("Future-AI信息科技学生评价系统")]), _c('h3', [_vm._v("Future-AI评价系统为教育主管单位、学校，提供信息科技学生素养和学业水平测评/评价服务")]), _c('a', {
    attrs: {
      "href": "http://demo.aipj.org.cn",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("查看系统演示")])])]), _c('a-col', {
    attrs: {
      "span": 10
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/banner1.png"),
      "alt": ""
    }
  })])], 1)], 1), _c('div', {
    staticClass: "section"
  }, [_vm._m(0), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Future-AI信息科技评价系统集成CMS信息发布、班级管理、题库考试系统、人工智能基础算法与应用领域作品提交、编程赛事提交与在线评审。 支持基于Python和C++等实操测评考试自动判卷等。针对低年级，提供语音读题功能。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle",
      "gutter": [24, 24]
    }
  }, [_c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('h3', [_vm._v("权限灵活")]), _c('p', [_vm._v("系统能够区分多个校区，并精细的控制每个角色、用户的权限。实现不同的人看不同的数据，不同的人看到不同的按钮。")]), _c('span', {
    staticClass: "more"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus-circle"
    }
  }), _vm._v(" 了解更多")], 1)])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('h3', [_vm._v("多端适配")]), _c('p', [_vm._v("兼容主流浏览器，适配各种PC设备、平板设备和手机设备。随时随地可以使用本平台。")]), _c('span', {
    staticClass: "more"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus-circle"
    }
  }), _vm._v(" 了解更多")], 1)])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('h3', [_vm._v("灵活安全")]), _c('p', [_vm._v("系统采用PaaS/SaaS架构，轻松实现定制开发。数据应用独立部署存储，保证数据安全性。")]), _c('span', {
    staticClass: "more"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus-circle"
    }
  }), _vm._v(" 了解更多")], 1)])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "card1"
  }, [_c('h3', [_vm._v("教学工具")]), _c('p', [_vm._v("系统默认集成了Scratch、ScratchJr、Python、Turtle、C++、C、Java等编程教学工具。")]), _c('span', {
    staticClass: "more"
  }, [_c('a-icon', {
    attrs: {
      "type": "plus-circle"
    }
  }), _vm._v(" 了解更多")], 1)])])], 1)], 1)])]), _c('div', {
    staticClass: "section"
  }, [_vm._m(1), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("专注于信息科技学科期末测评、阶段性教学评价、科技特长生选拔，无论你们遇到什么样的问题，我们都可以提供相应的解决方案。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('a-row', {
    attrs: {
      "gutter": [24, 24]
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/solu1.png"),
      "alt": ""
    }
  }), _c('h3', [_vm._v("专业题库资源")]), _c('p', [_vm._v("系统提供海量的信息科技（含人工智能学科题库资源），灵活的创建试卷和发起不同班级不同场次考试。我们的运营团队一对一操作指导。")])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/solu1.png"),
      "alt": ""
    }
  }), _c('h3', [_vm._v("PssS平台托管")]), _c('p', [_vm._v("根据您的需求，分为网页版直接使用，无需下载任何用户端软件。也可以为教育局或集团学校部署专属的系统，独立的域名，无忧托管到我们的PaaS平台，数据完全隔离。")])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/solu1.png"),
      "alt": ""
    }
  }), _c('h3', [_vm._v("在线智能生成评价报告")]), _c('p', [_vm._v("持续研发多种教学评价工具，围绕学科核心素养模型评价维度生成区域整体评价报告、学校版教学评价报告和学生个人学习评价报告，帮助教育管理者/教师根据评价数据改进教学方式方法。")])])])], 1)], 1)])]), _vm._m(2), _c('div', {
    staticClass: "section"
  }, [_vm._m(3), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("我们为以下机构和单位提供了系统开发、技术合作等服务。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('a-row', {
    attrs: {
      "gutter": [16, 16]
    }
  }, [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/c1.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/c2.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/c3.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6,
      "xl": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/c4.png"),
      "alt": ""
    }
  })])], 1)], 1)])]), _c('div', {
    staticClass: "section"
  }, [_vm._m(4), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("因为专业、专注信息科技学科领域，所以获得他们的认可。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('a-row', {
    attrs: {
      "gutter": [16, 16]
    }
  }, [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/case1.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/case2.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/case3.png"),
      "alt": ""
    }
  })])], 1)], 1)])]), _c('div', {
    staticClass: "section"
  }, [_vm._m(5), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("该系统具备人工智能核心素养模型和信息科技学生素养模型将准确测出学生的知识储备、特长发展、学习行为、学习漏洞等多方面的情况做出综合评价，为信息科技课堂教学和区域科技教育发展提供科学依据。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle",
      "gutter": [16, 16]
    }
  }, [_c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/cert.png"),
      "alt": ""
    }
  })]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "com-desc"
  }, [_c('p', [_vm._v("北京未来基因教合科技有限公司成立于 2017 年，总部设在北京。下设未来基因（北京）人工智能研究院。")]), _c('p', [_vm._v("未来基因，作为中国人工智能学会中小学工作委员会和中国自动化学会普及工作委员会副主任单位，正在不断为中国中小学人工智能教育的落地提供技术支撑和产业融合。")]), _c('p', [_vm._v("该系统是在综合中国自动化学会人工智能核心素养测评相关研究成果的基础上，整合国科大人工智能学院、清华大学、中国人民大学等的专家学术资源和未来基因(北京)人工智能研究院研发技术打造的一套针对中小学的人工智能、信息科技学科教育个性化教学测评系统。")])]), _c('a', {
    attrs: {
      "href": "https://weilaijiyin.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "btn"
  }, [_vm._v("前往官网")])])])], 1)], 1)])]), _c('div', {
    staticClass: "section"
  }, [_c('a-row', {
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("想要进一步沟通？")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "wrap1"
  }, [_c('br'), _c('br'), _c('p', [_vm._v("期待与您的进一步交流讨论，欢迎扫码添加微信！")])])])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/wxqrcode.png"),
      "alt": ""
    }
  })])], 1)], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("评价系统功能")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("解决方案")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("我们的数据")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("FutureAI信息科技评价系统集成CMS信息发布、班级管理、题库考试系统、人工智能基础算法与应用领域作品提交、编程赛事提交与在线评审。 支持基于Python和C++等实操测评考试自动判卷等。针对低年级，提供语音读题功能。")]), _c('div', {
    staticClass: "wrap1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/datacount.png"),
      "alt": ""
    }
  })])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("部分服务单位")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("服务案例")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("北京未来基因教育科技有限公司")]), _c('img', {
    attrs: {
      "src": require("../assets/divider.png"),
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };